// extracted by mini-css-extract-plugin
export default {"row":"Home_row__6m4hA","col":"Home_col__r1uBH","card":"Home_card__ARAPq"};